module.exports = "<ng-container *ngIf=\"!template; else contentTemplate\">\r\n    <i *ngIf=\"icon\"\r\n       class=\"button-icon {{icon}}\">\r\n    </i>\r\n    <div *ngIf=\"text\"\r\n         class=\"button-text\">\r\n        {{text}}\r\n    </div>\r\n</ng-container>\r\n<ng-template #contentTemplate>\r\n    <ng-content></ng-content>\r\n</ng-template>\r\n<tooltip *ngIf=\"tooltip\">\r\n    {{tooltip}}\r\n</tooltip>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/core/components/button/button.component.html
// module id = ./client-src/app/core/components/button/button.component.html
// module chunks = main